import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {
  JaarrapportageEntity,
  ClientEntity,
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {Subscription} from "rxjs";
import {Router} from "@angular/router";
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-activa',
  templateUrl: './activa.component.html',
  imports: [
    SharedUiDetailsModule,
    SharedUiFormControlsModule
  ],
  styleUrls: ['./activa.component.scss']
})
export class ActivaComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  private entitySubscription: Subscription | undefined;
  public client = {} as ClientEntity;
  public totalImvFg = {} as FormGroup;
  public totalMvaFg = {} as FormGroup;
  public totalVastgoedFg = {} as FormGroup;
  public totalFvaFg = {} as FormGroup;
  public totalVoorrFg = {} as FormGroup;
  public totalOhwFg = {} as FormGroup;
  public totalVordFg = {} as FormGroup;
  public totalVlotFg = {} as FormGroup;
  public totalEffFg = {} as FormGroup;
  public totalLmFg = {} as FormGroup;
  public somVastFg = {} as FormGroup;
  public somVlotFg = {} as FormGroup;
  public somTotaalFg = {} as FormGroup;
  public jrEntity = {} as JaarrapportageEntity;
  public year: number | undefined = {} as number;

  constructor(
    public algDataService: BokkzAlgDataService,
    public jrDataService: BokkzJrDataService)
  {
    this.totalImvFg = this.jrDataService.createFormGroupBalanceItem();
    this.totalMvaFg = this.jrDataService.createFormGroupBalanceItem();
    this.totalVastgoedFg = this.jrDataService.createFormGroupBalanceItem();
    this.totalFvaFg = this.jrDataService.createFormGroupBalanceItem();
    this.totalVordFg = this.jrDataService.createFormGroupBalanceItem();
    this.totalVoorrFg = this.jrDataService.createFormGroupBalanceItem();
    this.totalVlotFg = this.jrDataService.createFormGroupBalanceItem();
    this.totalEffFg = this.jrDataService.createFormGroupBalanceItem();
    this.totalLmFg = this.jrDataService.createFormGroupBalanceItem();
    this.totalOhwFg= this.jrDataService.createFormGroupBalanceItem();
    this.somVastFg = this.jrDataService.createFormGroupBalanceItem();
    this.somVlotFg = this.jrDataService.createFormGroupBalanceItem();
    this.somTotaalFg = this.jrDataService.createFormGroupBalanceItem();
  }

  ngOnInit(): void {
    this.algDataService.client.subscribe((value) => {
      this.client = value;
    });
    this.jrDataService.jaarrapportageEntity.subscribe((value) => {
      this.jrEntity = value;
      this.year = value.year;
      const balans = value.rapportage?.jaarrekeningen?.at(0)?.balans;
      if (balans) {
        if (balans.immaterieleVasteActiva?.intangibleAssets) {
          this.totalImvFg.patchValue(balans.immaterieleVasteActiva?.intangibleAssets)
        }
        if (balans.materieleVasteActiva?.propertyPlantEquipment) {
          this.totalMvaFg.patchValue(balans.materieleVasteActiva.propertyPlantEquipment)
        }
        if (balans.vastgoedbeleggingen?.investmentProperties) {
          this.totalVastgoedFg.patchValue(balans.vastgoedbeleggingen?.investmentProperties)
        }
        if (balans.financieleVasteActiva?.financialAssets) {
          this.totalFvaFg.patchValue(balans.financieleVasteActiva.financialAssets)
        }
        if (balans.voorraden?.inventories) {
          this.totalVoorrFg.patchValue(balans.voorraden.inventories)
        }
        if (balans.onderhandenProjecten?.constructionContractsAssets) {
          this.totalOhwFg.patchValue(balans.onderhandenProjecten.constructionContractsAssets)
        }
        if (balans.vorderingen?.receivables) {
          this.totalVordFg.patchValue(balans.vorderingen.receivables)
        }
        if (balans.effecten?.securitiesCurrent) {
          this.totalEffFg.patchValue(balans.effecten.securitiesCurrent)
        }
        if (balans.liquideMiddelen?.cashAndCashEquivalents) {
          this.totalLmFg.patchValue(balans.liquideMiddelen.cashAndCashEquivalents)
        }
        if (balans.vasteActiva?.assetsNoncurrent) {
          this.somVastFg.patchValue(balans.vasteActiva.assetsNoncurrent)
        }
        if (balans.vlottendeActiva?.assetsCurrent) {
          this.somVlotFg.patchValue(balans.vlottendeActiva.assetsCurrent)
        }
        if (balans.activa?.assets) {
          this.somTotaalFg.patchValue(balans.activa.assets)
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.entitySubscription) {
      this.entitySubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
  }
}
